import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AnnualPlanRow, AnnualPlanService } from '../../providers/annual-plans.services';
import { UsersProvider } from '../../../users/providers/users-provider';
import { AnnualPlanDialogFormAthletePlanNewComponent } from '../../components/dialog-form-athlete-plan-new/annual-plan-dialog-form-athlete-plan-new.component';
import { AnnualPlanDialogFormAthletePlanImportComponent } from '../../components/dialog-form-athlete-plan-import/annual-plan-dialog-form-athlete-plan-import.component';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { AnnualPlanRights, mapAnnualPlanRightsToItemRights } from '../../providers/annual-plan-rights';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AnnualPlan } from "../../../common/models/annual-plan";
import { Athlete } from "../../../common/models/athlete";
import { User } from "../../../common/models/user";
import { ModuleMenu } from "../../../common/models/menu";
import { SimpleMatDataSource } from "../../../common/providers/simple-mat-data-source";
import { Organization } from "../../../common/models/organization";
import { ConfigProvider } from "../../../config-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { ErrorManagerService } from "../../../common/providers/error-manager-service";
import { ConfirmDialogComponent } from "../../../common/components/confirm-dialog/confirm-dialog";
import { OrganizationRole } from "../../../common/models/organization-role";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  MatCell, MatCellDef, MatColumnDef,
  MatHeaderCell, MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import { MatIcon } from "@angular/material/icon";
import { MatFormField } from "@angular/material/form-field";
import { NgIf } from "@angular/common";
import { AthleteSideMenuComponent } from "../../../athletes/components/side-menu/side-menu";
import { MatInput } from "@angular/material/input";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatIconButton } from "@angular/material/button";
import { MainActionComponent } from "../../../common/components/main-action/main-action";
import { CalendarCommonModule } from "angular-calendar";
import { ApiBaseService } from "../../../common/providers/api-base-service";
import { LibraryService } from "../../../libraries/providers/library.services";

@Component({
  selector: 'app-annual-plan-athlete-list',
  templateUrl: './annual-plan-athlete-list.component.html',
  styleUrls: ['./annual-plan-athlete-list.scss'],
  imports: [
    AthleteSideMenuComponent,
    HeaderComponent,
    PageContentComponent,
    SideMenuComponent,
    Error404Component,
    Error401Component,
    ModuleContentComponent,
    TranslateModule,
    MatSortModule,
    MatTable,
    MatHeaderRow,
    MatRow,
    MatHeaderCell,
    MatCell,
    MatIcon,
    MatFormField,
    RouterLink,
    NgIf,
    MatHeaderRowDef,
    MatRowDef,
    MatInput,
    MatColumnDef,
    MatHeaderCellDef,
    MatCellDef,
    AppDatePipe,
    MatMenuTrigger,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatPaginator,
    MainActionComponent,
    CalendarCommonModule
  ],
  standalone: true
})
export class AnnualPlanAthleteListComponent implements OnInit, AfterViewInit, OnDestroy {
    public pageTitle = 'AnnualPlanList';
    public isLoading = true;
    public is401 = false;
    public is404 = false;
    public annualPlan: AnnualPlan = {} as AnnualPlan;
    public athleteUser: User = {} as User;
    public mainActions: ModuleMenu[] = [];
    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public columns: string[] = ['title', 'startedAt', 'endedAt', 'creator', 'isActive'];
    public organization: Organization = {} as Organization;

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | null = null;
    public annualPlanRights: AnnualPlanRights = new AnnualPlanRights(this.utils);
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        private title: Title,
        private currentUser: CurrentUser,
        public breadcrumbProvider: BreadcrumbProvider,
        private route: ActivatedRoute,
        private annualPlanService: AnnualPlanService,
        private userProvider: UsersProvider,
        private router: Router,
        private utils: UtilsProvider,
        private translator: TranslateService,
        private dialog: MatDialog,
        private toaster: MatSnackBar,
        private api: ApiBaseService,
        private currentUserRoles: CurrentUserRolesProvider,
        // private authorizationChecker: AuthorizationChecker,
        private librariesProvider: LibraryService,
        private errorManagerService: ErrorManagerService
    ) {
        // authorizationChecker.addVoter(new AnnualPlanVoter());
    }

    public ngOnInit() {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //  { organization: Organization; athlete: Athlete }
                this.organization = data.organization;

                if(!this.organization.id) return;
                this.annualPlanRights.evaluateScreenRights({
                    rolesIds: this.currentUserRoles.getRolesIds(this.organization.id)
                });
                if (!this.annualPlanRights.LIST) {
                    this.is401 = true;
                    return;
                }
                if ( this.annualPlanRights.ADD || this.annualPlanRights.EDIT || this.annualPlanRights.DELETE) {
                    this.columns.push('action');
                }

                if (data.athlete) {
                    this.athleteUser = data.athlete;
                }


                const loadPlans = new Promise((resolve, reject) => {
                    this.getAllAnnualPlans();
                    resolve(null);
                });

                const filterPredicates = new Promise((resolve, reject) => {
                    this.dataSource.filterPredicate = (row: AnnualPlanRow, filter: string) => {
                        const subject: string = this.utils.normalizeString(row.title +
                            row.creator.firstName + ' ' + row.creator.lastName
                        );
                        const filters: string[] = filter.split(' ');

                        for (const f of filters) {
                            if (!subject.includes(f)) {
                                return false;
                            }
                        }

                        return true;
                    };

                    resolve(null);
                });

                Promise.all([loadPlans, filterPredicates]).then(() => {

                    this.createPageTitle();
                    this.createBreadcrumb();
                    this.isLoading = false;
                });
            })
        );
    }

    public ngAfterViewInit() {
        this.initSorters();
        this.initNav();
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public onSortChange(event: any): void {
        this.dataSource.sortBy(event.active, event.direction);
    }

    public onFilterKeyup(filter: string): void {
        this.dataSource.filter = this.utils.normalizeString(filter);
    }

    public onAddClicked(): void {
        const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAthletePlanNewComponent, {
            data: {
                dialogTitle: 'AnnualPlan_New',
                organization: this.organization,
                athlete: this.athleteUser.athlete
            }
        });

        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                if (row) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Added'), '', { duration: 5000 });
                }
            })
        );
    }

    public onDuplicateAsModel(toDuplicate: AnnualPlanRow) {
      this.librariesProvider.getByOrganizationCode(this.organization.code!).subscribe({
        next: (library) => {
          const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAthletePlanNewComponent, {
            data: {
              dialogTitle: 'Make_a_model',
              formSaveActionTitle: 'Save',
              annualPlanRow: toDuplicate,
              organization: this.organization,
              athlete: this.athleteUser.athlete,
              duplicateAsModel: true,
              skipLangSelection: true,
              library,
              isLangSelectable: true,
            }
          });

          // Update the list by fetching all objects after dialog closed
          this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
              if (row) {
                this.toaster.open(this.translator.instant('Plan_saved_as_model'), '', { duration: 5000 });
              }
            })
          );
        }
      })
    }

    public onEditClicked(toModify: AnnualPlanRow) {
        const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAthletePlanNewComponent, {
            data: {
                dialogTitle: 'AnnualPlan_Edit',
                annualPlanRow: toModify,
                organization: this.organization,
                formSaveActionTitle: 'Save',
                isLangSelectable: true
            }
        });

        // Update the list by fetching all objects after dialog closed
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((annualPlan: any) => {
                if (annualPlan) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Edited'), '', { duration: 5000 });
                }
            })
        );
    }

    public onDeleteClicked(plan: AnnualPlan) {
        const dialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: 'AnnualPlanConfirmDeleteMembership',
                confirmActionText: 'Delete',
                confirmColor: 'primary'
            }
        });
        this.subscriptions.push(
            dialog.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.annualPlanService.remove(this.organization, plan).subscribe(() => {
                        this.getAllAnnualPlans();
                        this.toaster.open(this.translator.instant('AnnualPlan_Deleted'), '', { duration: 5000 });
                    }, (err) => {
                        this.toaster.open(err.error.message, '', { duration: 5000 });
                    });
                }
            })
        );
    }

    public onDuplicateClicked(toDuplicate: AnnualPlanRow) {
        toDuplicate = JSON.parse(JSON.stringify(toDuplicate)); // clone object
        toDuplicate.title = toDuplicate.title + ' (1)';

        const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAthletePlanNewComponent, {
            data: {
                dialogTitle: 'AnnualPlan_Duplicate',
                formSaveActionTitle: 'Duplicate',
                annualPlanRow: toDuplicate,
                organization: this.organization,
                athlete: this.athleteUser.athlete,
                toDuplicate: true,
                skipLangSelection: true,
                isLangSelectable: true
            }
        });

        // Update the list by fetching all objects after dialog closed
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                if (row) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Duplicated'), '', { duration: 5000 });
                }
            })
        );
    }

    public onImportClicked() {
        const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAthletePlanImportComponent, {
            data: {
                dialogTitle: 'AnnualPlan_Import',
                organization: this.organization,
                athlete: this.athleteUser.athlete,
                toDuplicate: true
            }
        });

        // Update the list by fetching all objects after dialog closed
        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                if (row) {
                    this.getAllAnnualPlans();
                    this.toaster.open(this.translator.instant('AnnualPlan_Duplicated'), '', { duration: 5000 });
                }
            })
        );
    }

    private initNav(): void {
        this.dataSource.paginator = this.paginator!;
    }

    private initSorters(): void {
        this.dataSource.addSortDefinition(
            'title',
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow(a.title.toLowerCase(), b.title.toLowerCase()),
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow(b.title.toLowerCase(), a.title.toLowerCase())
        );

        this.dataSource.addSortDefinition(
            'creator',
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow((`${a.creator.firstName} ${a.creator.lastName}`).toLowerCase(), (`${b.creator.firstName} ${b.creator.lastName}`).toLowerCase()),
            (a: AnnualPlanRow, b: AnnualPlanRow) => this.utils.sortRow((`${b.creator.firstName} ${b.creator.lastName}`).toLowerCase(), (`${a.creator.firstName} ${a.creator.lastName}`).toLowerCase())
        );
    }

    private updateAnnualPlan(...values: Object[]) {
        Object.assign(this.annualPlan, ...values);
    }

    protected onMarkAsActiveClicked(row: any): void {
        const dialogRef: any = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: row.isActive ? 'ConfirmAnnualPlanMarkAsInactive' : 'ConfirmAnnualPlanMarkAsActive',
                confirmActionText: row.isActive ? 'Disable' : 'Enable',
                color: 'accent'
            }
        });

        this.subscriptions.push(
            dialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                    this.annualPlanService.markAsActiveByAnnualPlan(this.organization, row).subscribe(() => {
                        this.getAllAnnualPlans();
                        this.toaster.open(this.translator.instant((row.isActive ? 'AnnualPlan_MarkedAsInActive' : 'AnnualPlan_MarkedAsActive')), '', { duration: 5000 });
                    });
                }
            })
        );
    }

    private createPageTitle() {
        this.pageTitle = this.translator.instant('AnnualPlanList');
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }

    private createBreadcrumb() {

        const crumbs: Crumb[] = [];

        if (!this.currentUserRoles.have(OrganizationRole.ID_ATHLETE, this.organization.id ??0)) {
            crumbs.push({
                shortTitle: 'Athletes',
                title: 'Athletes',
                url: '/' + this.organization!.code + '/athletes'
            });
        }
        crumbs.push({
            shortTitle: this.athleteUser.firstName?.substr(0, 1) + '. ' + this.athleteUser.lastName,
            title: this.athleteUser.firstName + ' ' + this.athleteUser.lastName,
            url: '/' + this.organization!.code + '/athletes/' + this.athleteUser.id
        });
        crumbs.push({
            shortTitle: 'Annual_plans',
            title: 'Annual_plans',
            url: this.router.url
        });
        this.breadcrumbProvider.setDefaultCrumbs(crumbs);
    }

    private getAllAnnualPlans() {
        this.subscriptions.push(
            this.annualPlanService.findAllByAthlete(this.organization, this.athleteUser.athlete!).subscribe((plans: AnnualPlan[]) => {
                // Map the API rights array to the structured rights object for each plan
                const plansWithMappedRights = plans.map(plan => ({
                    ...plan,
                    rights: mapAnnualPlanRightsToItemRights(plan.rights ?? [])
                }));
                this.dataSource.replaceAllWith(plansWithMappedRights);
            })
        );
    }

  protected readonly HTMLInputElement = HTMLInputElement;
}
